module.exports = __webpack_public_path__ + "img/enablebanking.a769e1de.svg";